(function(){
  /* Salpido gallery tweaks.
     1) Hovering a thumbnail shows that slide. Uses the thumbnail's position in the list, because
        data-media-position counts images and videos separately and breaks once a product has a video.
     2) Products whose first media is an image open on slide 2 (existing behaviour, kept).
        Products whose first media is a video open on the video and can return to it. */
  function slidesOf(gallery){
    var s = gallery && gallery.sliderInstance && gallery.sliderInstance.slider;
    return s || null;
  }
  function firstIsVideo(slider){
    var first = slider && slider.slides && slider.slides[0];
    return !!(first && first.dataset && (first.dataset.mediaType === 'video' || first.dataset.mediaType === 'external_video'));
  }
  function initHover(){
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('.product__thumbs-item.swiper-slide');
    thumbs.forEach(function(thumb, i){
      thumb.addEventListener('mouseenter', function(){
        var slider = slidesOf(gallery);
        if (slider) slider.slideTo(i, 0, false);
      });
    });
  }
  window.addEventListener('load', function(){ setTimeout(initHover, 800); });
  window.addEventListener('load', function(){
    setTimeout(function(){
      var gallery = document.querySelector('media-gallery');
      var slider = slidesOf(gallery);
      if (!slider || firstIsVideo(slider)) return;
      slider.on('beforeInit', function(){ slider.activeIndex = 1; });
      if (slider.activeIndex === 0) slider.slideTo(1, 0, false);
      slider.on('slideChange', function(){ if (slider.activeIndex === 0) slider.slideTo(1, 0, false); });
    }, 10);
  });
})();
